<div class="saving-modal">
  <div class="saving-spinner" aria-hidden="true"></div>
  <h4 class="saving-title">Saving &amp; publishing your content&hellip;</h4>
  <p class="saving-body">Finalizing your content, adding it to your shop, and publishing it to the WorldTumbler store for others to discover. This will only take a moment.</p>
</div>
